const merge = require('deepmerge')

const c = {
  states: {
    labels: {
      notactive: '未生效',
      active: '有效',
      pending: '待确认',
      expired: '过期',
      ended: '已结束',
      paid: '已支付',
      deleted: '已删除',
      unpaid: '未支付',
      verified: '已审核',
      review: '待审核',
      invalid: '无效',
      checked: '入住',
      delegated: '委托中',
      ordered: '完成签署',
      avaliable: '空闲',
      unavaliable: '不可用',
      unknown: '未知',
      canceled: '已取消',
    },
    classes: {
      notactive: '',
      active: 'olive',
      pending: 'orange',
      expired: 'red',
      paid: 'olive',
      ended: 'brown',
      deleted: 'grey',
      delegated: 'pink',
      unpaid: 'orange',
      verified: 'olive',
      review: 'yellow',
      invalid: 'grey',
      unavaliable: 'grey',
      avaliable: 'green',
      checked: 'olive',
      unknown: 'purple',
    },
  },
  utilities: {
    labels: {
      water: '冷水',
      hot_water: '热水',
      electricity: '电表',
      kitchen: '厨房电',
    },
    units: {
      water: '吨',
      hot_water: '吨',
      electricity: '千瓦时',
      kitchen: '千瓦时',
    },
    price: {
      water: 6,
      hot_water: 35,
      electricity: 1.3,
      kitchen: 2,
    },
  },
  bills: {
    actions: {
      checkout: '退房',
      sign_new_contract: '新签合同',
      renew_contract: '续签合同',
      new_rent: '缴纳租金',
      new_preorder: '新预定单',
      cancel_preorder: '取消预定单',
      charge: '水电充值',
      manual: '人工登记',
      manual_settle: '结算水电',
    },
  },
  genders: {
    0: '-',
    1: '男',
    2: '女',
  },
  rent_pay_unit_month: {
    0: '日租',
    12: '年付',
    6: '半年付',
    3: '季度付',
    1: '月付',
    default: month => `${month} 个月`,
  },
  payment_methods: {
    cash: '现金',
    credit: '信用卡',
    alipay: '支付宝',
    wechat: '微信',
    other: '其他',
  },
  native_errors: {
    canceled: '用户取消',
    duplicated: '重复运行',
    invaild: '无效输入',
    timeout: '等待超时',
    failed_to_connect: '无法连接设备',
    no_card_detected: '未检测到卡',
  },
  service_starts_date: '2017-05-01T00:00:00.000+0000',
}

let override = {}

try {
  override = require('../config.override.js') || {}
} catch (error) {}

const constants = merge(c, override.constants || {})

export default constants



// WEBPACK FOOTER //
// ./shared/constants.js